export const accordion = () => {
  const ACCORDION_ACTIVE = "accordion-active";

  const accordionInit = (accordionSection: HTMLElement) => {
    /* unique Id of current accordion */
    const accordionId = accordionSection.id;

    /* Use Id to get all accordion headers/items within it */
    const accordionHeaders = document.querySelectorAll<HTMLElement>(
      `#${accordionId} [js-accordion-header]`
    );

    /* No headers/items within accordion */
    if (!accordionHeaders) {
      return;
    }

    /* Add click event to each accordion header */
    accordionHeaders.forEach((accordionHeader) => {
      accordionHeader.addEventListener("click", function () {
        /* Get body text that is to be hidden / shown */
        const accordionBody = accordionHeader.nextElementSibling as HTMLElement;

        /* Target all accordion bodies except the clicked one within this accordion */
        /* Converted into an array to filter out the clicked accordion */
        const accordionBodiesArr = Array.from(
          document.querySelectorAll<HTMLElement>(
            `#${accordionId} [js-accordion-body]`
          )
        ).filter((el) => el !== accordionBody);

        /* Hide all other accordion bodies so that only one is ever open at a time */
        accordionBodiesArr.forEach((acc) => {
          acc.style.removeProperty("max-height");
          acc.previousElementSibling?.classList.remove(ACCORDION_ACTIVE);
          acc.previousElementSibling?.setAttribute("aria-expanded", "false");
        });

        /* Toggle open / close of clicked accordion */
        if (accordionBody.style.maxHeight) {
          accordionBody.style.removeProperty("max-height");
          this.classList.remove(ACCORDION_ACTIVE);
          this.setAttribute("aria-expanded", "false");
        } else {
          /* Max-height is set as an inline style as there is no way to know in css what height it would need to be set to. 
          Setting it to scroll height keeps the transition animation consistent when different accordions will have different amount of text */
          accordionBody.style.maxHeight = accordionBody?.scrollHeight + "px";
          this.classList.add(ACCORDION_ACTIVE);
          this.setAttribute("aria-expanded", "true");
        }
      });
    });
  };

  /* Get all accordions on page */
  const accordionSections =
    document.querySelectorAll<HTMLElement>("[js-accordion]");

  /* Loop over all of the accordions and apply functionality on each one */
  accordionSections.length > 0
    ? accordionSections.forEach((accordionSection) =>
        accordionInit(accordionSection)
      )
    : null;

  /* Fix for screen resize cutting off bottom of text. Readjust max-height for acitve accordions on resize  */
  window.addEventListener("resize", () => {
    const activeAccordions = document.querySelectorAll<HTMLElement>(
      `.${ACCORDION_ACTIVE}`
    );

    if (!activeAccordions.length) {
      return;
    }

    activeAccordions.forEach((activeAccordion) => {
      const activeAccordionBody =
        activeAccordion.nextElementSibling as HTMLElement;
      activeAccordionBody.style.maxHeight =
        activeAccordionBody?.scrollHeight + "px";
    });
  });
};
